import {AppDocPermissions} from '@/types/permissions/document'
import {AppDocSystemTypes} from '@/types/document/types'

export const state = {}

export const getters = {
    selectedDocTypePermissions: (state, getters, rootState, rootGetters) => {
        return rootGetters['documents/documentTypeSelected'] &&
        typeof rootGetters['documents/documentTypeSelected'].permissions === 'object'
            ? rootGetters['documents/documentTypeSelected'].permissions
            : {}
    },

    currentUserPermission: (state, getters, rootState, rootGetters) => getters.selectedDocTypePermissions[rootGetters.userUUID],

    hasFullAccess: (state, getters) => getters.currentUserPermission === AppDocPermissions.FULL,
    hasOwnOnlyAccess: (state, getters) => getters.currentUserPermission === AppDocPermissions.OWN_ONLY,
    hasReadOnlyAccess: (state, getters) => getters.currentUserPermission === AppDocPermissions.READ_ONLY,
    hasNoAccess: (state, getters) => getters.currentUserPermission === AppDocPermissions.NONE,

    checkCurrentUserIsDocTypeOwner: (state, getters, rootState, rootGetters) => dt => {
        return dt.user && dt.user.uuid && dt.user.uuid === rootGetters.userUUID
    },

    checkIsVisibleDocTypeForCurrentUser: (state, getters, rootState, rootGetters) => dt => {
        return rootGetters.isStaff ||
            getters.checkCurrentUserIsDocTypeOwner(dt) ||
            (typeof dt.permissions === 'object' &&
                dt.permissions[rootGetters.userUUID] &&
                dt.permissions[rootGetters.userUUID] !== AppDocPermissions.NONE)
    }
}

export const mutations = {}

export const actions = {}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
